export default __webpack_public_path__ + "static/media/lower-hand-new.10b06812.svg";